export const en = {
    translations: {
        navBar: {
            navBarLogo: '<GabrielDev />',
            aboutMe: 'About me',
            projects: 'Projects',
            contact: 'Contact me',
        },
        languageSelector: {
            portuguese: 'Portuguese',
            english: 'English',
        },
        wellcomePage: {
            getCv: 'GET CV',
            contact: 'Contact Me',
        },
        carer: {
            description: {
                introductionText: "I'm passionate about technology. I had my first experience with programming in 2013 after creating and maintaining Tibia servers using Lua and PHP for a little over a year.",
                carerDescription: 'In 2020, I obtained my first professional experience, which I continue to pursue to this day, as a mid-level full-stack developer. Along the way, I\'ve been in contact with various technologies, including PHP, Laravel, Node.js, Python, React, Vue.js, RabbitMQ, among others.'
            },
            butons: {
                seeMore: 'See more',
            },
            companies: {
                '123milhas': {
                    role: 'Desenvolvedor Backend Pleno',
                    description: `- Desenvolvimeno e manuenção em aplicação backend feita em laravel + mysql.
- Integração com Gateways de pagamento
- Definição de arquitetura, implemenação de cultura de testes unitarios
- Testes unitarios em aplicações laravel utilizando PHPUnit, Pest
- Jobs de alto desempenho usando sqs
- Integração com ci/cd, pipeline de testes/deploy no k8s`,
                },
                objective: {
                    role: 'Desenvolvedor Backend Pleno',
                    description: `- Prestando consultoria ao EBANX
- Integração com Gateways de pagamento
- Desenvolvimento e manutenção da Payment Page EBANX com frontend feito em React, criando testes unitários com Jest e testes de integração com cypress.
- Backend feito em PHP, utilizando DDD como metodologia de desenvolvimento, com testes unitários utilizando PHPUnit.
- CI/CD.`,
                },
                logcomex: {
                    role: 'Dev freelancer Full-stack',
                    description: `- Desenvolvimento e manutenção de sistemas com frontend feito em Vue + Nuxt.js e Typescript. 
Backend feito em Laravel + php, e banco de dados pgsql.
- Refatoração de um monólito feito em laravel para uma arquitetura de microserviços, utilizando Rabbitmq + Lumen.
- Criação de lambda functions na aws Feito com python + auroraDB postgre plugado a um SQS e SNS
- Testes unitários no frontend usando Jest.
- Testes unitários para aplicações php usando PHPunit.
- Testes unitários em aplicações python utilizando pytest`,
                },
                freelancer: {
                    role: 'Dev Fullstack Freelancer',
                    description: `- Desenvolvimento de software
- Criação de um Sistema de gestão 
- Javascript, Node, Vue.js
- Banco de Dados Mysql`,
                },
                teknisa: {
                    role: 'Estagiario de Programação',
                    description: `- Implantação de novas funcionalidades
- Desenvolvimento de software
- PHP, Javascript, Typescript, Json, Vue
- Banco de Dados Oracle SQL Developer`,
                }
            },
        }
    },
};
